export default {
  'tips.test': `测试啊啊啊`
}
